/** Bottom-left (−) / bottom-right (+) deck controls on card art. */
export function DeckOverlayButtons({ quantity, signedIn, onAdd, onRemove }) {
  if (!signedIn || !onAdd) return null;
  const q = quantity || 0;
  const plusLabel = q >= 1 ? `+ (${q})` : "+";

  return (
    <>
      {q >= 1 && (
        <button
          type="button"
          className="absolute bottom-2 left-2 z-[6] flex h-9 min-w-[2.25rem] items-center justify-center rounded-md border border-slate-400/40 bg-black/25 text-lg font-bold leading-none text-slate-100 shadow-sm backdrop-blur-[2px] hover:border-red-400/60 hover:bg-red-950/40 focus:outline-none focus:ring-2 focus:ring-amber-500/80"
          aria-label="Remove one copy from deck"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRemove?.();
          }}
        >
          −
        </button>
      )}
      <button
        type="button"
        className="absolute bottom-2 right-2 z-[6] flex h-9 min-w-[2.25rem] items-center justify-center rounded-md border border-amber-400/45 bg-black/25 px-2 text-sm font-bold text-amber-100 shadow-sm backdrop-blur-[2px] hover:border-amber-400/70 hover:bg-amber-950/40 focus:outline-none focus:ring-2 focus:ring-amber-500/80"
        aria-label="Add copy to deck"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onAdd?.();
        }}
      >
        {plusLabel}
      </button>
    </>
  );
}
